/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { SubOfficeListItemDto } from '../models/sub-office-list-item.dto';
import { SubOfficeStatus } from '../models/sub-office-status.enum';

export const SubOfficeListItemMapper = entity<SubOfficeListItemDto>({
    subOfficeStatus: enumeration(SubOfficeStatus),
});
